var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { runtime } from '../../Runtime';
export class TimeSwitch {
    tickingClock;
    switchTime;
    didReachSwitchMark = false;
    constructor(tickingClock, switchTime) {
        makeObservable(this);
        this.tickingClock = tickingClock;
        this.switchTime = switchTime;
    }
    get hasPassed() {
        return !this.isBelow;
    }
    get isBelow() {
        if (this.didReachSwitchMark)
            return false;
        const isActive = this.tickingClock.tickingTime < this.switchTime;
        if (!isActive) {
            // kill observing
            runtime.runtimeScheduler.scheduleForAnimationFrame(() => (this.didReachSwitchMark = true));
        }
        return isActive;
    }
}
__decorate([
    observable
], TimeSwitch.prototype, "didReachSwitchMark", void 0);
__decorate([
    computed
], TimeSwitch.prototype, "hasPassed", null);
__decorate([
    computed
], TimeSwitch.prototype, "isBelow", null);
